
import state from './moduleMailErrorState.js'
import mutations from './moduleMailErrorMutations.js'
import actions from './moduleMailErrorActions.js'
import getters from './moduleMailErrorGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
